import React from 'react';
import ApprovalSettingsContainer from '../../containers/approval/ApprovalSettingsContainer';

const ApprovalSettingsPage = () => {
  return <ApprovalSettingsContainer />;
};

export default ApprovalSettingsPage;
